import { render, staticRenderFns } from "./CorporationNewForm.vue?vue&type=template&id=0ea9a6c3"
import script from "./CorporationNewForm.vue?vue&type=script&lang=js"
export * from "./CorporationNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports